"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var ReactDOM = require("react-dom");
var dom_helpers_1 = require("../util/dom-helpers");
var classnames_1 = require("../util/classnames");
var _1 = require("../util/_");
var popup_1 = require("../popup");
var CustomPropTypes = require("../util/custom-prop-types");
var list_1 = require("../list");
var data_helpers_1 = require("../util/data-helpers");
var interaction_1 = require("../util/interaction");
var widget_helpers_1 = require("../util/widget-helpers");
var vdl_prefix_1 = require("../util/vdl-prefix");
var angle_down_1 = require("adp-react-icons/lib/fa/angle-down");
var search_1 = require("adp-react-icons/lib/fa/search");
var focus_mixin_1 = require("../mixins/focus-mixin");
var popup_scroll_manager_1 = require("../util/popup-scroll-manager");
var timeout_manager_1 = require("../util/timeout-manager");
var filter_1 = require("../util/filter");
var localizers_1 = require("../util/localizers");
var dflt = function (f) { return f === true ? 'startsWith' : f ? f : 'eq'; };
function localizedMessage(messageKey, locale) {
    return localizers_1.message.formatMessage('adp-react-components/dropdown-list/' + messageKey, undefined, locale);
}
function msgs(msgs, locale) {
    return __assign({ open: localizedMessage('OPEN', locale), filterPlaceholder: localizedMessage('FILTER_PLACEHOLDER', locale), emptyList: localizedMessage('EMPTY_LIST', locale), emptyFilter: localizedMessage('EMPTY_FILTER', locale), selected: localizedMessage('SELECTED', locale) }, msgs);
}
function getFilter(matcher, searchTerm, ctx) {
    searchTerm = !ctx.props.caseSensitive ?
        searchTerm.toLowerCase()
        : searchTerm;
    return function (item) {
        var val = data_helpers_1.dataText(item, ctx.props.textField);
        if (!ctx.props.caseSensitive) {
            val = val.toLowerCase();
        }
        return matcher(val, searchTerm);
    };
}
var DropdownList = /** @class */ (function (_super) {
    __extends(DropdownList, _super);
    function DropdownList(props) {
        var _this = _super.call(this, props) || this;
        _this._isMounted = false;
        _this._timeoutManager = new timeout_manager_1.TimeoutManager();
        _this._popupScrollManager = new popup_scroll_manager_1.PopupScrollManager();
        _this.setTimeout = function (key, callback, duration) {
            if (_this._isMounted) {
                return _this._timeoutManager.setTimeout(key, callback, duration);
            }
        };
        _this.handleBlur = function (event) {
            focus_mixin_1.handleBlur(_this, event, function (focused) {
                if (!focused) {
                    _this.close();
                }
            });
        };
        _this.handleFocus = function (event) {
            if (_this.props.disabled || _this.props.readOnly) {
                return;
            }
            focus_mixin_1.handleFocus(_this, event);
            // It's not enough to tell React to stop propagation, we need to also stop propagation of
            // of the native event to sibling event handlers we may not be aware of that would still
            // propagate the event up the tree. This fix is for dropdowns inside popovers inside slide-ins.
            event.stopPropagation();
            event.nativeEvent && event.nativeEvent.stopImmediatePropagation();
        };
        _this.handleAriaActiveDescendant = function (id) {
            if (id === _this.state.ariaActiveDescendant) {
                return;
            }
            _this.setState({
                ariaActiveDescendant: id
            });
        };
        _this._scrollTo = function (selected, list, focused) {
            return _this._popupScrollManager.scrollTo(selected, list, focused, _this.props.onMove);
        };
        _this.filterIndexOf = function (items, searchTerm) {
            var idx = -1;
            var matches = typeof _this.props.filter === 'function'
                ? _this.props.filter
                : getFilter(filter_1.default[dflt(_this.props.filter)], searchTerm, _this);
            if (!searchTerm
                || !searchTerm.trim()
                || (_this.props.filter && searchTerm.length < (_this.props.minLength || 1))) {
                return -1;
            }
            items.every(function (item, i) {
                if (matches(item, searchTerm, i)) {
                    idx = i;
                    return false;
                }
                return true;
            });
            return idx;
        };
        _this.filter = function (items, searchTerm) {
            var filter = _this.props.filter;
            var matches = typeof filter === 'string' ?
                getFilter(filter_1.default[filter], searchTerm, _this)
                : filter;
            if (!matches
                || !searchTerm
                || !searchTerm.trim()
                || searchTerm.length < (_this.props.minLength || 1)) {
                return items;
            }
            return items.filter(function (item, idx) { return matches(item, searchTerm, idx); });
        };
        _this._renderFilter = function (messages, id) {
            return (React.createElement("div", { ref: function (c) {
                    _this._filterWrapper = c;
                }, className: vdl_prefix_1.vdlPrefix('dropdown-list__filter') },
                React.createElement("input", { id: id, ref: function (c) {
                        _this._filter = c;
                    }, className: vdl_prefix_1.vdlPrefix('dropdown-list__filter__input'), autoComplete: "off", placeholder: _1.result(messages.filterPlaceholder, _this.props), value: _this.state.searchTerm, onChange: function (e) { return _this.updateSearchTerm(e.target.value); } }),
                React.createElement("span", { className: vdl_prefix_1.vdlPrefix('dropdown-list__filter__search') },
                    React.createElement(search_1.default, null))));
        };
        //FIXME @widgetEditable
        _this._onSelect = function (data) {
            _this.close();
            widget_helpers_1.notify(_this.props.onSelect, data);
            _this.change(data);
            _this.focus(_this);
        };
        _this._onChange = function (data) {
            _this.setState({
                selectedItem: data
            }, function () {
                // console.log(this.state.selectedItem);
            });
        };
        _this._click = function (e) {
            if (_this.props.disabled || _this.props.readOnly) {
                return;
            }
            var wrapper = _this._filterWrapper;
            if (!_this.props.filter || !_this.state.open) {
                _this.toggle();
            }
            else if (!dom_helpers_1.contains(ReactDOM.findDOMNode(wrapper), e.target)) {
                _this.close();
            }
            widget_helpers_1.notify(_this.props.onClick, e);
        };
        _this._keyDown = function (e) {
            if (_this.props.disabled || _this.props.readOnly) {
                return;
            }
            var key = e.key;
            var alt = e.altKey;
            var list = _this._list;
            var filtering = _this.props.filter;
            var focusedItem = _this.state.focusedItem;
            var selectedItem = _this.state.selectedItem;
            var isOpen = _this.state.open;
            var closeWithFocus = function () {
                _this.close();
                ReactDOM.findDOMNode(_this).focus();
            };
            var change = function (item, fromList) {
                if (!item) {
                    return;
                }
                if (fromList) {
                    _this._onSelect(item);
                }
                else {
                    _this.change(item);
                }
            };
            widget_helpers_1.notify(_this.props.onKeyDown, [e]);
            if (e.defaultPrevented) {
                return;
            }
            if (key === 'End') {
                if (isOpen) {
                    _this.setState({
                        focusedItem: list.last()
                    });
                }
                else {
                    change(list.last());
                }
                e.preventDefault();
            }
            else if (key === 'Home') {
                if (isOpen) {
                    _this.setState({
                        focusedItem: list.first()
                    });
                }
                else {
                    change(list.first());
                }
                e.preventDefault();
            }
            else if (key === 'Escape' && isOpen) {
                e.preventDefault();
                closeWithFocus();
            }
            else if ((key === 'Enter' || (key === ' ' && !filtering)) && isOpen) {
                e.preventDefault();
                change(_this.state.focusedItem, true);
            }
            else if (key === ' ' && !filtering && !isOpen) {
                e.preventDefault();
                _this.open();
            }
            else if (key === 'ArrowDown') {
                if (alt) {
                    _this.open();
                }
                else if (isOpen) {
                    _this.setState({
                        focusedItem: list.next(focusedItem)
                    });
                }
                else {
                    change(list.next(selectedItem));
                }
                e.preventDefault();
            }
            else if (key === 'ArrowUp') {
                if (alt) {
                    closeWithFocus();
                }
                else if (isOpen) {
                    _this.setState({
                        focusedItem: list.prev(focusedItem)
                    });
                }
                else {
                    change(list.prev(selectedItem));
                }
                e.preventDefault();
            }
        };
        _this._keyPress = function (e) {
            if (_this.props.disabled || _this.props.readOnly) {
                return;
            }
            widget_helpers_1.notify(_this.props.onKeyPress, [e]);
            if (e.defaultPrevented) {
                return;
            }
            if (!(_this.props.filter && _this.state.open)) {
                _this.search(String.fromCharCode(e.which), function (item) {
                    if (_this._isMounted && _this.state.open) {
                        _this.setState({
                            focusedItem: item
                        });
                    }
                    else {
                        item && _this.change(item);
                    }
                });
            }
        };
        _this.change = function (data) {
            if (!data_helpers_1.valueMatcher(data, _this.props.value, _this.props.valueField)) {
                widget_helpers_1.notify(_this.props.onChange, data);
                _this.updateSearchTerm('');
                _this.close();
            }
        };
        _this.updateSearchTerm = function (searchTerm) {
            var _a = _this.props, filter = _a.filter, value = _a.value, valueField = _a.valueField;
            var open = _this.state.open;
            var data = _this.props.data;
            var processed = filter ? _this.filter(data, searchTerm) : data;
            var idx = data_helpers_1.dataIndexOf(data, value, valueField);
            _this.setState({
                filteredData: (open && filter) ? processed : undefined,
                selectedItem: processed[idx],
                focusedItem: processed[!~idx ? 0 : idx],
                searchTerm: searchTerm
            }, function () {
                widget_helpers_1.notify(_this.props.onSearch, _this.state.searchTerm);
            });
        };
        _this.focus = function (target) {
            var inst = target || (_this.props.filter && _this.state.open ? _this._filter : _this._input);
            if (dom_helpers_1.activeElement() !== ReactDOM.findDOMNode(inst)) {
                ReactDOM.findDOMNode(inst).focus();
            }
        };
        _this.onOpening = function () {
            var disabled = _this.props.disabled;
            if (!disabled) {
                if (_this._list) {
                    _this._list.forceUpdate();
                }
            }
        };
        _this._data = function () {
            return _this.state.filteredData || (_this.props.data ? _this.props.data.concat() : []);
        };
        _this.search = function (character, cb) {
            var word = ((_this._searchTerm || '') + character).toLowerCase();
            if (!character) {
                return;
            }
            _this._searchTerm = word;
            _this.setTimeout('search', function () {
                var list = _this._list;
                var key = _this.state.open ? 'focusedItem' : 'selectedItem';
                var item = list.next(_this.state[key], word);
                if (item === _this.state[key]) {
                    item = list.prev(_this.state[key], word);
                }
                _this._searchTerm = '';
                if (item) {
                    cb(item);
                }
            }, _this.props.delay);
        };
        _this.open = function () {
            if (!_this.state.open) {
                _this.setState({
                    open: true
                }, function () {
                    widget_helpers_1.notify(_this.props.onToggle, true);
                });
            }
        };
        _this.close = function () {
            if (_this.state.open) {
                _this.setState({
                    open: false
                }, function () {
                    widget_helpers_1.notify(_this.props.onToggle, false);
                });
            }
        };
        _this.toggle = function () {
            if (_this.state.open) {
                _this.close();
            }
            else {
                _this.open();
            }
        };
        var _a = _this.props, filter = _a.filter, value = _a.value, valueField = _a.valueField, defaultOpen = _a.defaultOpen, defaultSearchTerm = _a.defaultSearchTerm;
        var open = _this.props.open !== undefined ? _this.props.open : defaultOpen || false;
        var searchTerm = _this.props.searchTerm !== undefined ? _this.props.searchTerm : defaultSearchTerm || '';
        var data = _this.props.data;
        var processed = filter ? _this.filter(data, searchTerm) : data;
        var initialIdx = data_helpers_1.dataIndexOf(data, value, valueField);
        _this.state = {
            filteredData: (open && filter) ? processed : undefined,
            selectedItem: processed[initialIdx],
            focusedItem: processed[initialIdx] || data[0],
            open: open
        };
        return _this;
    }
    DropdownList.prototype.componentDidMount = function () {
        var autoFocus = this.props.autoFocus;
        this._isMounted = true;
        if (autoFocus) {
            this._input.focus();
        }
    };
    DropdownList.prototype.componentWillReceiveProps = function (nextProps) {
        var filter = nextProps.filter, value = nextProps.value, valueField = nextProps.valueField;
        var data = nextProps.data;
        var searchTerm = nextProps.searchTerm !== undefined ? nextProps.searchTerm : this.state.searchTerm || '';
        var open = nextProps.open !== undefined ? nextProps.open : this.state.open;
        var processed = filter ? this.filter(data, searchTerm) : data;
        var idx = data_helpers_1.dataIndexOf(data, value, valueField);
        var newState = {
            filteredData: (open && filter) ? processed : undefined,
            selectedItem: processed[idx],
            focusedItem: processed[!~idx ? 0 : idx]
        };
        if (this.state.open !== open) {
            newState.open = open;
        }
        if (this.state.searchTerm !== searchTerm) {
            newState.searchTerm = searchTerm;
        }
        this.setState(newState);
    };
    DropdownList.prototype.componentDidUpdate = function () {
        if (this._list) {
            widget_helpers_1.validateList(this._list);
        }
    };
    DropdownList.prototype.componentWillUnmount = function () {
        this._isMounted = false;
        this._timeoutManager.clearAllTimeouts();
    };
    DropdownList.prototype.render = function () {
        var _a, _b, _c, _d, _e;
        var _this = this;
        var _f = this.props, ariaInvalid = _f.ariaInvalid, ariaRequired = _f.ariaRequired, id = _f.id, className = _f.className, tabIndex = _f.tabIndex, filter = _f.filter, valueField = _f.valueField, textField = _f.textField, groupBy = _f.groupBy, busy = _f.busy, dropUp = _f.dropUp, placeholder = _f.placeholder, value = _f.value, locale = _f.locale, ValueComponent = _f.valueComponent, hasError = _f.hasError;
        var List = this.props.listComponent;
        var messages = this.props.messages;
        var data = this.props.data;
        List = List || (groupBy && list_1.ListGroupable) || list_1.List;
        var elementProps = _1.omit(this.props, Object.keys(DropdownList.propTypes));
        var listProps = _1.omit(_1.pick(this.props, Object.keys(List.propTypes)), ['className', 'style']);
        var popupProps = _1.omit(_1.pick(this.props, Object.keys(popup_1.Popup.propTypes)), ['className', 'style']);
        var _g = this.state, focusedItem = _g.focusedItem, selectedItem = _g.selectedItem, focused = _g.focused, ariaActiveDescendant = _g.ariaActiveDescendant, open = _g.open;
        var items = this._data();
        var disabled = interaction_1.isDisabled(this.props);
        var readOnly = interaction_1.isReadOnly(this.props);
        var valueItem = data_helpers_1.dataItem(data, value, valueField); // take value from the raw data
        var listID = widget_helpers_1.instanceId(this, '__listbox');
        var shouldRenderList = !disabled && (widget_helpers_1.isFirstFocusedRender(this) || open);
        messages = msgs(messages, locale);
        var dropdownListClassNames = (_a = {},
            _a[vdl_prefix_1.vdlPrefix('dropdown-list')] = true,
            _a[vdl_prefix_1.vdlPrefix('dropdown-list--disabled')] = disabled,
            _a[vdl_prefix_1.vdlPrefix('dropdown-list--readonly')] = readOnly,
            _a[vdl_prefix_1.vdlPrefix('dropdown-list--focus')] = focused,
            _a[vdl_prefix_1.vdlPrefix('dropdown-list--open')] = open,
            _a[vdl_prefix_1.vdlPrefix('dropdown-list--dropup')] = dropUp,
            _a);
        var pickerClassNames = (_b = {},
            _b[vdl_prefix_1.vdlPrefix('dropdown-list__picker')] = true,
            _b[vdl_prefix_1.vdlPrefix('dropdown-list__picker--readonly')] = readOnly,
            _b[vdl_prefix_1.vdlPrefix('dropdown-list__picker--busy')] = busy,
            _b);
        var inputContainerClassNames = (_c = {},
            _c[vdl_prefix_1.vdlPrefix('dropdown-list__input-container')] = true,
            _c[vdl_prefix_1.vdlPrefix('dropdown-list__input-container--focus')] = focused,
            _c[vdl_prefix_1.vdlPrefix('dropdown-list__input-container--open')] = open,
            _c[vdl_prefix_1.vdlPrefix('dropdown-list__input-container--error')] = hasError,
            _c);
        var inputClassNames = (_d = {},
            _d[vdl_prefix_1.vdlPrefix('dropdown-list__input')] = true,
            _d);
        var inputPlaceholderClassNames = (_e = {},
            _e[vdl_prefix_1.vdlPrefix('dropdown-list__input__placeholder')] = true,
            _e);
        return (React.createElement("div", __assign({}, elementProps, { ref: function (c) {
                _this._input = c;
            }, id: id, role: "combobox", tabIndex: disabled || readOnly ? -1 : tabIndex || 0, "aria-invalid": ariaInvalid, "aria-expanded": open, "aria-haspopup": true, "aria-owns": listID, "aria-busy": !!busy, "aria-live": !open && 'polite', "aria-autocomplete": "list", "aria-activedescendant": ariaActiveDescendant, "aria-disabled": disabled, "aria-readonly": readOnly, "aria-required": ariaRequired, onKeyDown: this._keyDown, onKeyPress: this._keyPress, onClick: this._click, onBlur: this.handleBlur, onFocus: this.handleFocus, className: classnames_1.classNames(className, dropdownListClassNames) }),
            React.createElement("div", { className: classnames_1.classNames(inputContainerClassNames) },
                React.createElement("span", { className: classnames_1.classNames(pickerClassNames) },
                    React.createElement(angle_down_1.default, null),
                    React.createElement("span", { className: vdl_prefix_1.vdlPrefix('aria-message') }, _1.result(messages.open, this.props))),
                React.createElement("div", { className: classnames_1.classNames(inputClassNames) }, !valueItem && placeholder
                    ? React.createElement("span", { className: classnames_1.classNames(inputPlaceholderClassNames) }, placeholder)
                    : this.props.valueComponent
                        ? React.createElement(ValueComponent, { item: valueItem })
                        : data_helpers_1.dataText(valueItem, textField))),
            React.createElement(popup_1.Popup, __assign({}, popupProps, { open: open, onOpen: function () { return _this.focus(); }, onOpening: function () { return _this.onOpening(); } }),
                React.createElement("div", null,
                    filter && this._renderFilter(messages, id),
                    shouldRenderList &&
                        React.createElement(List, __assign({ ref: function (c) {
                                _this._list = c;
                            } }, listProps, { data: items, id: listID, "aria-live": open && 'polite', "aria-labelledby": widget_helpers_1.instanceId(this), "aria-hidden": !this.props.open, selected: selectedItem, focused: open ? focusedItem : null, onSelect: this._onSelect, onMove: this._scrollTo, onAriaActiveDescendant: this.handleAriaActiveDescendant, messages: {
                                emptyList: data.length
                                    ? messages.emptyFilter
                                    : messages.emptyList
                            } }))))));
    };
    DropdownList.propTypes = {
        //-- controlled props -----------
        value: PropTypes.any,
        onChange: PropTypes.func,
        open: PropTypes.bool,
        onToggle: PropTypes.func,
        //------------------------------------
        ariaRequired: PropTypes.bool,
        id: PropTypes.string,
        defaultOpen: PropTypes.bool,
        defaultSearchTerm: PropTypes.string,
        data: PropTypes.array,
        valueField: PropTypes.string,
        textField: CustomPropTypes.accessor,
        valueComponent: CustomPropTypes.elementType,
        itemComponent: CustomPropTypes.elementType,
        listComponent: CustomPropTypes.elementType,
        groupComponent: CustomPropTypes.elementType,
        groupBy: CustomPropTypes.accessor,
        onSelect: PropTypes.func,
        searchTerm: PropTypes.string,
        onSearch: PropTypes.func,
        busy: PropTypes.bool,
        delay: PropTypes.number,
        dropUp: PropTypes.bool,
        duration: PropTypes.number,
        disabled: PropTypes.bool,
        disabledItems: PropTypes.array,
        readOnly: PropTypes.bool,
        readOnlyItems: PropTypes.array,
        messages: PropTypes.shape({
            open: PropTypes.node,
            emptyList: PropTypes.node,
            emptyFilter: PropTypes.node,
            filterPlaceholder: PropTypes.node,
            selected: PropTypes.node
        }),
        filter: CustomPropTypes.filter,
        onClick: PropTypes.func,
        onKeyDown: PropTypes.func,
        onKeyPress: PropTypes.func,
        className: PropTypes.string,
        tabIndex: PropTypes.number,
        placeholder: PropTypes.string,
        onMove: PropTypes.func,
        caseSensitive: PropTypes.bool,
        minLength: PropTypes.number,
        locale: PropTypes.string,
        multi: PropTypes.bool,
        hasError: PropTypes.bool,
        autoFocus: PropTypes.oneOf([true, false, 'selectAll'])
    };
    DropdownList.defaultProps = {
        delay: 500,
        value: '',
        data: [],
        searchTerm: '',
        caseSensitive: false,
        minLength: 1,
        duration: 200,
        autoFocus: false
    };
    return DropdownList;
}(React.PureComponent));
exports.DropdownList = DropdownList;
